export default "__VITE_ASSET__90072cfb__"